import { Button, Icon, Typography, VerticalDivider } from '@smartgift/frontend-toolkit';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { configs } from '@hero/configs';
import { UploadInput } from '@hero/molecules';

import * as S from './style';

function FileUploadArea({
  handleFile,
  fakeDelay = 1000,
  status,
  successButton,
  csvFileUrl = `${configs.publicUrl}/assets/docs/sgb-contact-upload-template.csv`,
  xlsFileUrl = `${configs.publicUrl}/assets/docs//sgb-contact-upload-template.xlsx`,
  infoText = 'dragAndDropFileInfo'
}) {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  return (
    <S.Wrapper>
      <Typography variant="body1Bold" style={{ marginBottom: 16 }}>
        {t('dragAndDropSpreadSheet')}
      </Typography>
      <UploadInput
        handleFile={(...args) => {
          setIsLoading(true);
          handleFile(...args);
          setTimeout(() => {
            setIsLoading(false);
          }, fakeDelay);
        }}
        status={isLoading ? 'loading' : status ? status : 'idle'}
        successButton={successButton}
      />
      <S.DownloadArea>
        <Button
          as="a"
          variant="link"
          color="secondary"
          href={xlsFileUrl}
          download
          target="_blank"
          rel="noreferrer"
        >
          <Icon name="xls" />
          {t('downloadSpreadsheetTemplate', { type: 'XLS' })}
        </Button>
        <VerticalDivider $margin="0" $height="24px" />

        <Button
          as="a"
          variant="link"
          color="secondary"
          href={csvFileUrl}
          target="_blank"
          download
          rel="noreferrer"
        >
          <Icon name="csv" />
          {t('downloadSpreadsheetTemplate', { type: 'CSV' })}
        </Button>
      </S.DownloadArea>
      <S.InfoText>
        <Icon name="tooltip" size="sm" />
        {t(infoText)}
      </S.InfoText>
    </S.Wrapper>
  );
}

export { FileUploadArea };
